import { format, formatDefaultLocale } from 'd3-format';
import { objToMoment, momentToStr, guessDateFormat } from './date';

// TODO: Define the correct values for the SI prefixes
const defaultPrefixes = ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];

const localeFormat = {
  'de-DE': {
    decimal: ',',
    thousands: '.',
    grouping: [3],
    currency: ['', '\u00a0€'],
    prefixes: ['y', 'z', 'a', 'f', 'p', 'nano', 'mikro', 'milli', '', ' Tsd.', ' Mio.', ' Mrd.', ' Bio.', ' Brd.', ' Tri.', ' Trd.', ' Qdi.'],
  },
  'en-GB': {
    decimal: '.',
    thousands: ',',
    grouping: [3],
    currency: ['£', ''],
    prefixes: ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'million', 'billion', 'trillion', 'P', 'E', 'Z', 'Y'],
  },
  'en-US': {
    decimal: '.',
    thousands: ',',
    grouping: [3],
    currency: ['$', ''],
    prefixes: ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'million', 'billion', 'trillion', 'P', 'E', 'Z', 'Y'],
  },
};

export const formatNumber = (obj: number, numberFormat: any, locale: string = 'de-DE') => {
  const formatObj = formatDefaultLocale(localeFormat[locale]);

  // float rounding hack
  // https://github.com/d3/d3-format/issues/27
  const roundMatch = numberFormat.match(/\.(\d)[~]?f/);
  if (roundMatch && roundMatch[1] > 0) {
    obj += Number.EPSILON * obj;
  }

  const strObj: string = formatObj.format(numberFormat)(obj);
  return swapLocalePrefix(strObj, locale);
};

export const formatField = (obj: any, fieldFormat?: any, addPreSuffix: boolean = true, inputLocale: string = 'en-US'): any => {
  if (obj === undefined || obj === null) return '';
  if (!fieldFormat) return obj; // || typeof obj === 'string'

  let { formatType } = fieldFormat;
  const { date, number, locale, prefix, suffix } = fieldFormat;

  // TODO SCREAM AT SOMEONE!!
  if (formatType === undefined) {
    // TODO dirty hack if object that is inputed is already a moment object
    if (typeof obj !== 'object') {
      const momentGuess = guessDateFormat(obj);
      if (typeof obj === 'number' || !Number.isNaN(+obj)) formatType = 'number';
      if (typeof obj === 'string' && momentGuess) formatType = 'date';
    }
  }

  if (typeof obj === 'object' && obj.constructor && obj.constructor.name === 'Date') {
    formatType = 'date';
  }

  if (formatType === 'date' && date) {
    const { inputFormat, dateFormat } = date;
    if (typeof obj === 'object') {
      obj = momentToStr(obj, dateFormat, locale);
    } else {
      obj = objToMoment(obj, inputFormat, inputLocale);
      obj = momentToStr(obj, dateFormat, locale);
    }
  }

  if (formatType === 'number' && !Number.isNaN(obj)) {
    let { numberFormat, showSign } = number;
    const formatObj = formatDefaultLocale(localeFormat[locale]);

    // float rounding hack
    // https://github.com/d3/d3-format/issues/27
    const roundMatch = numberFormat.match(/\.(\d)[~]?f/);
    if (roundMatch && roundMatch[1] > 0) {
      obj += Number.EPSILON * obj;
    }

    if (obj === 0 && showSign) {
      numberFormat = numberFormat.replace('+', '-');
    }

    obj = formatObj.format(numberFormat)(obj);
    obj = swapLocalePrefix(obj, locale);
  }

  if (addPreSuffix) {
    if (prefix && prefix.length > 0) {
      obj = prefix + obj;
    }

    if (suffix && suffix.length > 0) {
      obj = obj + suffix;
    }
  }

  return obj;
};

/**
 * Sadly i found no other solution than replacing the prefixes
 */
const swapLocalePrefix = (string: string, locale: string) => {
  const match = string.match(/[A-Za-z]/);
  if (match) {
    const idx = defaultPrefixes.indexOf(match[0]);
    string = string.replace(match[0], localeFormat[locale].prefixes[idx]);
  }

  return string;
};

const formatSchema = {
  formatType: 'number | string | date',
  locale: 'string - from ref list',
  number: {
    numberFormat: 'string generated',
    decimalPlaces: 'int (locale defines decimal separator)',
    digitGrouping: 'boolean (locale defines group separator)',
    shorten: 'boolean (shorten to SI units or something else?)',
  },
  date: {
    inputFormat: 'input -> year?',
    dateFormat: 'format string',
    locale: 'string - from ref list',
  },
  style: {
    font: '',
    size: 13,
    color: 'black',
    bold: false,
    italic: false,
  },
  prefix: 'string',
  suffix: 'string',
};

export const toCamelCase = (name) => name
    .split('-')
    .reduce((a, b) => a + b.charAt(0).toUpperCase() + b.slice(1))
    .split('_')
    .reduce((a, b) => a + b.charAt(0).toUpperCase() + b.slice(1));

export const capitalize = (name) => {
  if (typeof name !== 'string') {
    return '';
  }

  return name.charAt(0).toUpperCase() + name.slice(1);
}

export const isIterable = (obj: any) => {
  // checks for null and undefined
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
}